import React from 'react';
import { createBrowserRouter } from 'react-router';
//@ts-ignore
import { RouterProvider } from 'react-router/dom';

import AdminLayout from 'src/layouts/AdminLayout';
import AppLayout from 'src/layouts/AppLayout';
import ChallengesAdmin from 'src/pages/Admin/ChallengesAdmin';
import DashbordAdmin from 'src/pages/Admin/DashboardAdmin';
import HighlightsAdmin from 'src/pages/Admin/HighlightsAdmin';
import ItemsAdmin from 'src/pages/Admin/ItemsAdmin';
import LeaderboardAdmin from 'src/pages/Admin/LeaderboardAdmin';
import PlayersAdmin from 'src/pages/Admin/PlayersAdmin';
import PlayerViewAdmin from 'src/pages/Admin/PlayerViewAdmin';
import RaffleAdmin from 'src/pages/Admin/RaffleAdmin';
import RafflesAdmin from 'src/pages/Admin/RafflesAdmin';
import SlotBattlesAdmin from 'src/pages/Admin/SlotBattlesAdmin';
import StoreAdmin from 'src/pages/Admin/StoreAdmin';
import StoreLogs from 'src/pages/Admin/StoreLogs';
import Cases from 'src/pages/Cases';
import Casino from 'src/pages/Casino';
import Challenges from 'src/pages/Challenges';
import FAQ from 'src/pages/FAQ';
import Giveaway from 'src/pages/Giveaway';
import Giveaways from 'src/pages/Giveaways';
import Highlights from 'src/pages/Highlights';
import Hunt from 'src/pages/Hunt';
import Hunts from 'src/pages/Hunts';
import { Landing } from 'src/pages/Landing';
import Leaderboard from 'src/pages/Leaderboard';
import { PlayerProfile } from 'src/pages/PlayerProfile';
import { PlayerSettings } from 'src/pages/PlayerSettings';
import PrivacyPolicy from 'src/pages/PrivacyPolicy';
import Raffle from 'src/pages/Raffle';
import Raffles from 'src/pages/Raffles';
import { SlotBattles } from 'src/pages/SlotBattles';
import { Store } from 'src/pages/Store';
import TermsOfService from 'src/pages/TermsOfService';
import { VIP } from 'src/pages/Vip';
import { routes } from 'src/routes';

import LeaderboardLayout from './layouts/LeaderboardLayout';
import VipLayout from './layouts/VipLayout';
import ChannelsAdmin from './pages/Admin/ChannelsAdmin';

const router = createBrowserRouter([
  {
    path: routes.home,
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Landing />,
      },

      {
        path: '/admin',
        element: <AdminLayout />,
        children: [
          { path: 'dashboard', element: <DashbordAdmin /> },
          { path: 'raffles', element: <RafflesAdmin /> },
          { path: 'raffles/:id', element: <RaffleAdmin /> },
          { path: 'challenges', element: <ChallengesAdmin /> },
          { path: 'highlights', element: <HighlightsAdmin /> },
          { path: 'items', element: <ItemsAdmin /> },
          { path: 'store', element: <StoreAdmin /> },
          { path: 'store-log', element: <StoreLogs /> },
          { path: 'battles', element: <SlotBattlesAdmin /> },
          { path: 'users', element: <PlayersAdmin /> },
          { path: 'users/:id', element: <PlayerViewAdmin /> },
          { path: 'leaderboard', element: <LeaderboardAdmin /> },
          { path: 'leaderboard/:id', element: <LeaderboardAdmin /> },
          { path: 'channels', element: <ChannelsAdmin /> },
        ],
      },
      {
        path: routes.casino,
        element: <Casino />,
      },

      {
        path: routes.leaderboard,
        element: <LeaderboardLayout />,
        children: [
          {
            path: routes.leaderboardSponsor,
            element: <Leaderboard />,
          },
        ],
      },

      {
        path: routes.vip,
        element: <VipLayout />,
        children: [
          {
            path: routes.vipSponsor,
            element: <VIP />,
          },
        ],
      },

      {
        path: routes.oldVip,
        element: <VipLayout />,
        children: [
          {
            path: routes.oldVipSponsor,
            element: <VIP />,
          },
        ],
      },

      {
        path: routes.leaderboardSponsor,
        element: <Leaderboard />,
      },
      {
        path: routes.highlights,
        element: <Highlights />,
      },
      {
        path: routes.challenges,
        element: <Challenges />,
      },
      {
        path: routes.giveaways,
        element: <Giveaways />,
      },
      {
        path: routes.giveaway,
        element: <Giveaway />,
      },
      {
        path: routes.raffles,
        element: <Raffles />,
      },
      {
        path: routes.raffle,
        element: <Raffle />,
      },
      {
        path: routes.cases,
        element: <Cases />,
      },
      {
        path: routes.battles,
        element: <SlotBattles />,
      },
      {
        path: routes.hunts,
        element: <Hunts />,
      },
      {
        path: routes.hunt,
        element: <Hunt />,
      },
      {
        path: routes.store,
        element: <Store />,
      },
      {
        path: routes.profile,
        element: <PlayerProfile />,
      },
      {
        path: routes.settings,
        element: <PlayerSettings />,
      },
      {
        path: routes.tos,
        element: <TermsOfService />,
      },
      {
        path: routes.faq,
        element: <FAQ />,
      },
      {
        path: routes.privacyPolicy,
        element: <PrivacyPolicy />,
      },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
